import axios from 'axios';
// import { getToken } from '@iso/lib/helpers/utility';
import { select } from 'redux-saga/effects';
// import actions from '../../redux/auth/actions';

const timeout = 60000;
const apiUrl = process.env.REACT_APP_API_URL;

let headers = {
    'Accept': 'application/json',
    'Content-Type': 'application/json',
};

export function* encryptedGet(uri, data, page, sort) {
    if (page) {
        headers = {
            ...headers,
            Range: `${page.page || 1}-${page.limit || 10}`,
        };
    }
    if (!sort) {
        sort = {
            sort: 'asc',
            sortBy: 'createdAt',
        };
    }
    const params = data ? toParams(data) : '';
    const sortField = `&sort=${sort.sort === 'asc' ? '' : '-'}${sort.sortBy}`;
    return yield encryptedFetch(`${apiUrl}${uri}?${params}${sortField}`, {
        headers: headers,
        method: 'GET',
    });
}

export function* encryptedPost(uri, data) {
    return yield encryptedFetch(`${apiUrl}${uri}`, {
        headers: headers,
        method: 'POST',
        data,
    });
}

export function* encryptedPut(uri, data) {
    return yield encryptedFetch(`${apiUrl}${uri}`, {
        headers: headers,
        method: 'PUT',
        data,
    });
}

export function* encryptedDelete(uri, data) {
    return yield encryptedFetch(`${apiUrl}${uri}`, {
        headers: headers,
        method: 'DELETE',
        data,
    });
}

// Helpers
function toParams(data) {
    const url = Object.keys(data).map((k) => {
        return `${encodeURIComponent(k)}=${encodeURIComponent(data[k])}`;
    }).join('&');
    return url;
}

export function* encryptedFetch(url, options) {
    const state = yield select();
    const keys = state.EncryptDecrypt.encryptReqIdSuccess;
    if (keys) {
        headers = {
            ...headers,
            ...keys
        }
    }
    return yield fetch(url, options)
}

export function* fetch(url, options) {
    const result = yield axios.request({
        ...options,
        url,
        baseURL: apiUrl,
        timeout: timeout,
        headers: headers
    }).then((res) => {
        return res;
    }).catch((error) => {
        return error
    })
    if (result.status) {
        return result;
    } else {
        if (result.response) {
            return result.response;
        }
    }
}